<!-- 邀请函 -->
<template>
  <div class='main-container'>
    <my-header></my-header>
    <div class="container">
        <div class="invitation-top">
              <div class="invitation-title">
                <img src="../../assets/images/inviteList/inviteBg_title.png" alt="">
              </div>
              <p>
                  您好：
              </p>
              <p style="text-indent: 30px;">
              我司于 {{$root.dateFormat("YYYY-mm-dd",startDate)}}日 启动 {{extWFlowForm.bidItemName}}，现邀请贵公司参与投标活动，需贵司提供相关方案及与我项目相匹配度的业绩证明。
              </p>
              <p style="text-indent: 30px; margin-top: 10px;">
                如确认参与，请于{{$root.$root.dateFormat("YYYY-mm-dd",endDate)}}日之前回复，谢谢！
              </p>
              <div style="text-align: right;">
                  <p>
                      联系人：{{extWFlowForm.handleUserName}}
                  </p>
                  <p>
                      联系电话：{{extWFlowForm.handleUserPhone}}
                  </p>
              </div>
              <div style="text-align: center; margin-top: 15px; background: transparent;">
                <el-button type="text" class="hover" style="margin-right: 30px;" @click="reject">不参与</el-button>
                <el-button type="text" class="hover" @click="join">参与</el-button>
              </div>
        </div>
        <div class="invitation-bottom">
        </div>

    </div>
    <!-- <my-footer></my-footer> -->
  </div>
</template>

<script>

import MyHeader from '../common/Header.vue'
import MyFooter from '../common/Footer.vue'
export default {
//import引入的组件需要注入到对象中才能使用
  components: {
        MyHeader, MyFooter
  },
  data() {
    return {
      extWFlowForm: {},
      wFlowFormInfo: {},
        startDate:'',
      endDate: '',
      dealId: ''
    }
  },
//方法集合
  methods: {
    join(){
      let that = this;
        that.$confirm('确定参与该招标吗？',{
            type: 'warning'
        }).then(() => {
            that.$root.postHttp('/v1/outerformflowHS/invitationCommit', {
              dealId: this.dealId,
              joinFlag: 1
            }, function (res) {
                that.$alert(res.data.msg,{
                    type: 'success'
                });
                that.$router.push('/gateway/index');
            });
        }).catch(() => {
            // 取消按钮回调
        });
    },
    reject(){
      let that = this;
        that.$confirm('确定不参与该招标吗？',{
            type: 'warning'
        }).then(() => {
            that.$root.postHttp('/v1/outerformflowHS/invitationCommit', {
              dealId: this.dealId,
              joinFlag: 0
            }, function (res) {
                that.$alert(res.data.msg,{
                    type: 'success'
                });
                that.$router.push('/gateway/index');
            });
        }).catch(() => {
            // 取消按钮回调
        });
    },
    getDetail() {
        let that = this;
        this.$root.postHttp('/v1/outerformflowHS/getInvitation', {dealId: this.dealId}, (res) => {
            that.wFlowFormInfo = res.data.data.wflowFormInfo;
            that.extWFlowForm = res.data.data.extWFlowForm;

            that.startDate = res.data.data.smyDeals.createDate;
            that.endDate = res.data.data.smyDeals.dealEndTime;
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.dealId = this.$route.params.dealId;
    this.getDetail();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

},
}
</script>
<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";
.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 70px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .invitation-top {
      color: #333333;

      .invitation-title {
        text-align: center;
        margin-bottom: 15px;
      }
      padding: 0 80px;
      box-sizing: border-box;
      width: 864px;
      height: 520px;
      margin: 0 auto;
      font-size: 14px;
      line-height: 30px;
      background: url('../../assets/images/inviteList/inviteBg_up.png') top;
        background-size: 100% 95%;
      img {
        margin-top: 30px;
          height: 42px;
      }
    }

    .invitation-bottom {
      width: 912px;
      height: 230px;
      margin: 0 auto;
      margin-top: -225px;
      background: url('../../assets/images/inviteList/inviteBg_down.png') no-repeat bottom;
        background-size: 100% 95%;
    }

    .el-form-item__error{
        width: 300px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }
    .f14 {
        font-size: 14px !important;
    }
    & .unit {
        width: 100px;
        margin-right: 5px;
    }
    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }
    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }
    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }
    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }
    & h5 {
        padding: 0 30px;
    }
    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }
    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }
    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
      width: 100%;
        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }
}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/{
  text-align: left;
  .file-list {
    margin-top: 10px;
  }
  .file-button{
      margin-top:-5px;
  }
}
.hover:hover{
    color: #007aff;
}
</style>



// WEBPACK FOOTER //
// src/pages/bid/invitation.vue